import React, { useState } from "react";
import { BUTTON_PRIMARY } from "../assets/constants/Constants";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { LS_LOCAL_LANGUAGE } from "../assets/constants/BrowserStorageKeys";

const ButtonComponent = ({
  width,
  title,
  handleClick,
  startIcon,
  type = BUTTON_PRIMARY,
  disabled = false,
  variant = "contained",
  customClass = "",
  buttonId = "",
  endIcon = null,
  align = "center",
  centerIcon,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const localLanguage = localStorage.getItem(LS_LOCAL_LANGUAGE);
  const { t } = useTranslation();

  const onClickHandler = async () => {
    if (disabled || isLoading) return;

    setIsLoading(true);
    try {
      const handleClickPromise = handleClick?.();
      const timeoutPromise = new Promise((resolve) =>
        setTimeout(resolve, 2000)
      );

      await Promise.all([handleClickPromise, timeoutPromise]);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const translateLocal = (ln, key) => {
    if (localLanguage) {
      const fixedT = i18n.getFixedT(ln);
      return fixedT(key);
    }
  };

  const renderContent = () => {
    if (isLoading) {
      return (
        <>
          {/* Only show loader when loading */}
          <span className="loader-container">
            <span className="loader"></span>
          </span>
        </>
      );
    }

    return (
      <>
        {/* LEFT ICON */}
        {startIcon && <span className="btn-icon left">{startIcon}</span>}

        {/* TEXT or centerIcon */}
        {centerIcon ? (
          <span className="btn-icon center">{centerIcon}</span>
        ) : (
          <div className="btn-text">
            <span>{t(title)}</span>
            {localLanguage && translateLocal(localLanguage, title) !== t(title) && (
              <span className="secondary">{translateLocal(localLanguage, title)}</span>
            )}
          </div>
        )}

        {/* RIGHT ICON */}
        {endIcon && <span className="btn-icon right">{endIcon}</span>}
      </>
    );
  };

  return (
    <div className={`button-container align-${align}`}>
      <button
        id={buttonId}
        className={`button ${type} ${disabled ? "disabled-button" : ""} ${isLoading ? "loading" : ""} ${customClass}`}
        onClick={onClickHandler}
        disabled={disabled || isLoading}
        style={width ? { width } : {}}
      >
        {renderContent()}
      </button>
    </div>
  );
};

export default ButtonComponent;